import { render, staticRenderFns } from "./MapPoints.vue?vue&type=template&id=3bb73ceb&scoped=true&"
import script from "./MapPoints.vue?vue&type=script&lang=ts&"
export * from "./MapPoints.vue?vue&type=script&lang=ts&"
import style0 from "./MapPoints.vue?vue&type=style&index=0&id=3bb73ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb73ceb",
  null
  
)

export default component.exports